var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Boxtype"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "orderid",
      "type": "text",
      "placeholder": _vm.$t('common.orderID')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('shipment.orderFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (!_vm.fromDateFlt) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fromDateFltErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('shipment.orderToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (!_vm.toDateFlt) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toDateFltErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.errorResolutionStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {}]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('pickingReport.orderStatusPlaceholder')))]), _vm._v(" "), _vm._l((_vm.orderstatuslist), function(ordstatus) {
    return _c('option', {
      domProps: {
        "value": ordstatus
      }
    }, [_vm._v("\n                          " + _vm._s(ordstatus))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getfailedinvoicedata(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                        " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-6 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.invioceErrorList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }), _vm._v(" "), (_vm.selectedList.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-2 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshMultipleInvoice
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.refreshSelected')))])]) : _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-2 cardlistheader"
  }), _vm._v(" "), (_vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-2 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.resultCount))])]) : _vm._e(), _vm._v(" "), (_vm.download && _vm.listerrordata.length > 0) ? _c('div', {
    staticClass: "col-md-2 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2"
  }, [(_vm.show && _vm.listerrordata.length) ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getfailedinvoicedata(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listerrordata.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-2"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary "
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "parentCheckBox"
    },
    on: {
      "click": _vm.selectAllCheckbox
    }
  }), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.$t('unicommerce.invoiceError.errorStatus')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.uniwareShipmentID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.wmsordercreationdate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipByDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.noofattempts')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.firstErrorDateandTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.lastErorDateandTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.invoiceError.lasterror')))])])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listerrordata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.status)), (data.status == "NotResolved") ? _c('span', [_c('i', {
      staticClass: "fa fa-refresh fa-lg",
      staticStyle: {
        "cursor": "pointer",
        "color": "brown"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.refreshInvoice(data)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "checkbox1",
      attrs: {
        "type": "checkbox",
        "id": data.orderid
      },
      domProps: {
        "value": data.orderid
      },
      on: {
        "click": function($event) {
          _vm.singleSelected(data)
        }
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.uniwareshipid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.wmsordercreationdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.shipbydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.noofattempts))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.firsterrordateandtime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.lasterordateandtime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.lasterror))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-680ecd8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680ecd8e","hasScoped":true}!./src/views/components/invoiceErrorReport/invoiceErrorReport.component.html
// module id = 830
// module chunks = 0